'use client';
import { useIsDesktop } from '@/_hooks/useBreakpoint';

import React from 'react';
import Desktop from './responsive/desktop';
import Mobile from './responsive/mobile';
import { IProps } from './_types';

const CRating = ({
  review,
  productId,
  orderData,
  product,
  refetch,
}: IProps) => {
  const isDesktop = useIsDesktop();

  return isDesktop ? (
    <Desktop
      review={review}
      productId={productId}
      orderData={orderData}
      product={product}
      refetch={refetch}
    />
  ) : (
    <Mobile
      review={review}
      productId={productId}
      orderData={orderData}
      product={product}
      refetch={refetch}
    />
  );
};

export default CRating;
